import { render } from "./star-icon.svg?vue&type=template&id=a103637a"
import script from "./star-icon.svg?vue&type=script&lang=js"
export * from "./star-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src806/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__